module.exports = __webpack_public_path__ + "images/Ping_Identity-a4cf3b.png";